import React from "react";
import { TableCell, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";
import {Box} from "@mui/material";
export const CustomTableCell = ({
  value,
  id,
  enableTootip,
  fontColor,
  children
}) => {
  const style = {
    padding: "10px",
  };
  return (
    <>
      <TableCell sx={style} id={id}>
        <Box sx={{display:'flex'}}>
        <Typography color={fontColor} noWrap={false}>
          {enableTootip === true ? (
            <Tooltip title={value}>
              {value?.toString().length > 15
                ? value?.toString().slice(0, 8) + "..."
                : value?.toString()}
            </Tooltip>
          ) : (
            value
          )}
        </Typography>
        {children}

        </Box>
        
      </TableCell>
    </>
  );
};
